import { captureException } from "@sentry/react";
import { createFileRoute } from "@tanstack/react-router";
import getPageTitle from "lib/utils/getPageTitle";
import type { ReactNode } from "react";
import { Helmet as Head } from "react-helmet-async";
import CrashyButton from "ui/buttons/CrashyButton";
import withAuthentication from "../../components/withAuthentication";

const CrashTestPage = (): ReactNode => {
  return (
    <>
      <Head>
        <title>{getPageTitle("Debug - Crash Test")}</title>
      </Head>
      <div>
        <button onClick={() => captureException("Debug page crash test")}>Trigger handled error (handled)</button>
        <button
          onClick={() => {
            throw new Error("Debug page crash test (unhandled)");
          }}
        >
          Trigger unhandled error
        </button>
        <CrashyButton>Trigger a React render error</CrashyButton>
      </div>
    </>
  );
};

export const Route = createFileRoute("/debug/crash-test")({
  component: withAuthentication(CrashTestPage, { superAdmin: true }),
});
